import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getCartItems } from 'toolkit/cart/cartSlice';
import { getDeliveryAddress } from 'toolkit/delivery/deliverySlice';
import { getUserPoint } from 'toolkit/point/pointSlice';
import { setIsPopupActive } from 'modules/status';
import { COUPON_ID_APP_INSTALL } from 'utils/constants';

/** 로컬스토리지의 쿠폰 발급 기록에 따라 쿠폰 팝업의 active 상태 업데이트 && (쿠폰, 카트아이템 조회) */
function useUserSelectCouponAndPoint(users, from) {
  const dispatch = useDispatch();
  useEffect(() => {
    if (from) return; // 다른 자사 서비스에서 진입한 유저의 경우 mall API 이용불가(현재 모다올 서비스에서 위드비컨 앱 웹뷰로 진입 시 mall API 사용할때 이슈있음)
    if (users) {
      dispatch(getCartItems(users[0].user_id));
      dispatch(getDeliveryAddress(users[0].user_id));
      dispatch(getUserPoint(users[0].user_id));

      let issuedCoupons = localStorage.getItem('issuedCoupons');

      if (!issuedCoupons) {
        dispatch(setIsPopupActive(true));
        return;
      }
      issuedCoupons = JSON.parse(issuedCoupons);
      if (issuedCoupons[users[0].user_id]?.includes(COUPON_ID_APP_INSTALL)) {
        dispatch(setIsPopupActive(false));
        return;
      }
      dispatch(setIsPopupActive(true));
    } else {
      dispatch(setIsPopupActive(true));
    }
  }, [users]);
}

export default useUserSelectCouponAndPoint;
